export default "__VITE_ASSET__ByR5XIH3__"